var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"col-33",on:{"click":_vm.sendToShow}},[_c('div',{staticClass:"img-video",style:(("background:url(" + (_vm.data.snippet.thumbnails.medium.url) + ") center/cover no-repeat"))},[_c('a',{staticClass:"play"})]),_vm._v(" "),_c('a',{staticClass:"link-video",domProps:{"innerHTML":_vm._s(_vm.data.snippet.title)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcd71352","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/video-el.vue
// module id = null
// module chunks = 